import { render, staticRenderFns } from "./EvalCompetence.vue?vue&type=template&id=48084098&scoped=true"
import script from "./EvalCompetence.vue?vue&type=script&lang=js"
export * from "./EvalCompetence.vue?vue&type=script&lang=js"
import style0 from "./EvalCompetence.vue?vue&type=style&index=0&id=48084098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48084098",
  null
  
)

export default component.exports